import useTranslation from '../../../Hooks/useTranslation';
import * as yup from 'yup';
import useScope from '../../Scope/Hooks/useScope';
import { getCurrencyCode } from '../Components/Inputs/FormattedPriceInput/PriceCurrency';
import { useAppContext } from '../../../Services/AppContext';
import { getFormattedPriceAsFloat } from '../Services/priceFormat.service';

export function useInputValidation() {
	const { t } = useTranslation();
	const { minimalPriceInputValue } = useScope();
	const { currency, globalTemplate } = useAppContext();

	const getPriceInputErrorMessage = (inputName: string) => {
		const base: string = `${t(inputName)} ${t(
			'validation.form.mustBeAtLeast',
		)}`;
		switch (globalTemplate) {
			case 'peru':
			case 'ecuador':
			case 'mexico':
			case 'colombia':
				return `${base} ${getCurrencyCode(currency)} ${minimalPriceInputValue}`;
			default:
				return `${base} ${minimalPriceInputValue} ${getCurrencyCode(currency)}`;
		}
	};

	const getPriceInputValidation = (
		inputName: string,
		required: boolean = false,
		allowZero: boolean = false,
	) => {
		const errorMessage = getPriceInputErrorMessage(inputName);
		const scheme = yup
			.mixed()
			.test('is-price', t('validation.form.mustFillNumber') ?? '', value => {
				if (value === null || value === undefined) {
					return false;
				}
				if (typeof value === 'number') {
					return true;
				}
				if (typeof value === 'string') {
					const numberValue = getFormattedPriceAsFloat(value);
					return !isNaN(numberValue);
				}
				return false;
			})
			.test('is-valid', errorMessage, function (value) {
				const val = getFormattedPriceAsFloat(value);
				if (allowZero) {
					return val === 0 || val >= minimalPriceInputValue;
				}
				return val >= minimalPriceInputValue;
			});

		return required ? scheme.required(t(inputName)) : scheme;
	};

	return {
		getPriceInputValidation,
	};
}
